/**
 * MAIN COMPONENT ENTRY POINT
 *
 * The main component is a wrapper which encapsulates other components. Also,
 * the router inserts the required components here depending on the URL.
 *
 * @version 0.1
 */

import React from 'react';

import './Main.style.scss';

import reduxStore from './../../reduxStore';
import { FormattedMessage } from 'react-intl';

import Header from './../../reusable/Header/Header.index.jsx';
import BackToTop from './../../reusable/BackToTop/BackToTop.index.jsx';
import Footer from './../../reusable/Footer/Footer.index.jsx';
import LoadingSpinner from './../../reusable/LoadingSpinner/LoadingSpinner.index.jsx';
import MessagePopups from './../../reusable/MessagePopup/MessagePopup.index.jsx';
import BackgroundMessage from './../../reusable/BackgroundMessage/BackgroundMessage.index';


export default class Main extends React.Component {

    constructor(props) {
        super(props);
        this.state = reduxStore.getState();
    }

    componentWillMount() {

        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState());
            }
        );

    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    componentDidMount() {
        if(this.state.user.appSettings.isPendoEnabled) {
            if(!window.pendo) return;
            let appState = this.state;
            window.pendo.updateOptions({
                visitor: {
                    id: appState.user.userId ? appState.user.userId : 'unknown-user-id',
                    custom: null,
                    interfaceLanguage: appState.user.preferences.language,
                    appVersion: appState.header.version
                },

                account: {
                    id: appState.user.customerName ? appState.user.customerName : 'unknown-account-id'
                    // name:         // Optional
                    // planLevel:    // Optional
                    // planPrice:    // Optional
                    // creationDate: // Optional

                    // You can add any additional account level key-values here,
                    // as long as it's not one of the above reserved names.
                }
            });
        }
    }

    render() {

        return (
            <div className='app-wrapper'>
                {this.state.spinners.fullPageSpinner ?
                    <div className="full-page-spinner">
                        <div className="full-page-spinner__transparent-overlay"></div>
                        <div className="full-page-spinner__text-spinner">
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.loggingOut.spinner" />
                        </div>
                    </div>
                    : null}
                <LoadingSpinner fixedSpinner={true} isVisible={this.state.spinners.mainSpinner.count > 0} />
                <Header />
                <div className='app-content-wrapper'>
                    <MessagePopups />
                    {this.props.children}
                </div>
                <BackgroundMessage/>
                <BackToTop />
                <Footer
                    version={this.state.header.version}
                    interfaceLanguage={this.state.user.preferences.language}
                />
                <div id="modal-root"></div>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/Main/Main.index.jsx